import { render, staticRenderFns } from "./licenca.vue?vue&type=template&id=37bc2d92&"
import script from "./licenca.vue?vue&type=script&lang=js&"
export * from "./licenca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports